{
  "nl": {
    "issue_category": {
      "labels": {
        "backup_category": "Vervangende categorie",
        "category_name": "Categorienaam",
        "delete_category": "Categorie \"{name}\" verwijderen?",
        "delete_category_disclaimer": "Alle nazorgpunten met deze categorie worden toegewezen aan de categorie die u hieronder selecteert.",
        "integration_warning": "Een integratie met de Nazorg module op uw platform is actief. Vraag het ons als u categorieën wilt maken of bewerken.",
        "new_category": "Categorie"
      }
    }
  }
}
